/* eslint-disable no-loop-func */
import initState from "./initState";

import * as types from "store/types";
import { updateObject, deepClone, encryptData } from "utils";
import { NOTIFICATIONS, CONTENT } from "consts";

function showLoginPage(state) {
  return updateObject(state, { loading: false });
}

function loginUserStart(state) {
  return updateObject(state, {
    login: updateObject(state.login, {
      loading: true,
      error: {
        show: false,
        msg: ""
      }
    })
  });
}

function loginUserSuccess(state, action) {
  const details = action.message;
  const serverDetails = {
    pnsServerIp: details.user.pnsServer
  };
  if (
    localStorage.getItem("rememberMe") === null ||
    !JSON.parse(localStorage.getItem("rememberMe")).rememberMe
  ) {
    if (localStorage.getItem("rememberMe") === null) {
      localStorage.setItem(
        "rememberMe",
        JSON.stringify({ rememberMe: false, loggedInTime: new Date() })
      );
    } else if (!JSON.parse(localStorage.getItem("rememberMe")).rememberMe) {
      localStorage.setItem(
        "rememberMe",
        JSON.stringify({ rememberMe: false, loggedInTime: new Date() })
      );
    }
  }
  localStorage.setItem("mirrorId", encryptData(details.user.mirrorId));
  localStorage.setItem("origin", details.user.origin);
  localStorage.setItem("token", details.token);
  localStorage.setItem(
    "serverDetails",
    encryptData(JSON.stringify(serverDetails))
  );

  return updateObject(state, {
    loading: false,
    isAuthenticated: true,
    login: updateObject(state.login, {
      loading: false
    })
  });
}

function showLoginError(state, action) {
  return updateObject(state, {
    login: updateObject(state.login, {
      loading: false,
      error: {
        show: true,
        msg:
          action.params && action.params.accountCancelled
            ? CONTENT.signup.cancelledAccount.updatedSuccess
            : action.params && action.params.accountBlocked
            ? CONTENT.signup.blockedAccount.updatedSuccess
            : action.params && action.params.sessionExists
            ? CONTENT.signup.sessionAlreadyExists.updatedSuccess
            : ""
      }
    })
  });
}

function hideLoginError(state) {
  return updateObject(state, {
    login: updateObject(state.login, {
      error: {
        show: false,
        msg: ""
      }
    })
  });
}

function logoutUser(state, action) {
  if (action.redirect) {
    return updateObject(state, {
      loading: true,
      isAuthenticated: false,
      isFirst: false
    });
  } else
    return updateObject(state, {
      loading: false,
      isAuthenticated: false,
      isFirst: false
    });
}

function setIsFirstTime(state) {
  return updateObject(state, {
    isFirst: false
  });
}

function setIsWelcome(state) {
  return updateObject(state, {
    isWelcome: false
  });
}

function resetRegistrationFailedMessage(state) {
  const updatedState = { ...state };
  return updateObject(state, {
    signup: updateObject(state.signup, {
      error: {
        show: false,
        msg: ""
      }
    })
  });
}

function createAccountFailure(state, action) {
  const updatedState = { ...state };
  localStorage.setItem("mirrorId", encryptData(action.loginId));
  updatedState.isAuthenticated = false;
  updatedState.loginId = action.loginId;
  if (action.details.message === "Emailid Already exists") {
    action.details.message = NOTIFICATIONS.auth.emailExists;
  }
  updatedState.signup = updateObject(updatedState.signup, {
    loading: false,
    error: {
      show: true,
      msg: action.details.message
    }
  });
  delete action.details.message;

  return updateObject(state, updatedState);
}

function createAccountStart(state, action) {
  return updateObject(state, {
    signup: updateObject(state.signup, {
      loading: true,
      error: {
        show: false,
        msg: ""
      }
    })
  });
}

function createPromoAccountStart(state, action) {
  return updateObject(state, {
    signup: updateObject(state.signup, {
      loading: true,
      error: {
        show: false,
        msg: ""
      }
    })
  });
}

function createAccountSuccess(state, action) {
  const updatedState = { ...state };
  const details = action.details;

  const serverDetails = {
    pnsServerIp: details.user.pnsServer
  };
  localStorage.setItem(
    "rememberMe",
    JSON.stringify({ rememberMe: false, loggedInTime: new Date() })
  );
  localStorage.setItem("mirrorId", encryptData(details.user.mirrorId));
  localStorage.setItem("token", action.details.token);
  localStorage.setItem("origin", details.user.origin);
  localStorage.setItem(
    "serverDetails",
    encryptData(JSON.stringify(serverDetails))
  );

  updatedState.isAuthenticated = true;
  updatedState.isFirst = true;
  //for welcome popup
  updatedState.isWelcome = true;
  updatedState.signup = updateObject(updatedState.signup, {
    loading: false,
    error: {
      show: false,
      msg: ""
    }
  });

  return updateObject(state, updatedState);
}

function checkAuthStart(state) {
  return updateObject(state, { loading: true });
}

function checkAuthSuccess(state, action) {
  const details = action.message;
  const serverDetails = {
    pnsServerIp: details.pnsServer
  };

  localStorage.setItem("mirrorId", encryptData(details.mirrorId));
  localStorage.setItem(
    "serverDetails",
    encryptData(JSON.stringify(serverDetails))
  );

  return updateObject(state, {
    isAuthenticated: true,
    loading: false
  });
}

function cleanLocalStorage(state) {
  localStorage.removeItem("rememberMe");
  localStorage.removeItem("mirrorId");
  localStorage.removeItem("token");
  localStorage.removeItem("serverDetails");
  localStorage.removeItem("ccDetails");
  localStorage.removeItem("billing");
  localStorage.removeItem("origin");
  localStorage.removeItem("dToken");
  if (document.getElementById("conv_check"))
    document.getElementById("conv_check").remove();
  return state;
}

function passwordResetStart(state, action) {
  return updateObject(state, {
    passwordReset: {
      loading: true
    }
  });
}

function passwordResetSuccess(state, action) {
  return updateObject(state, {
    passwordReset: updateObject(state.passwordReset, {
      loading: false,
      error: false,
      message: action.message
    })
  });
}

function passwordResetFailure(state, action) {
  return updateObject(state, {
    passwordReset: updateObject(state.passwordReset, {
      loading: false,
      error: true,
      message: action.message
    })
  });
}

function passwordValidateStart(state, action) {
  return updateObject(state, {
    passwordValidate: {}
  });
}

function passwordValidateSuccess(state, action) {
  return updateObject(state, {
    passwordValidate: updateObject(state.passwordValidate, {
      success: true,
      message: action.data.username
    })
  });
}

function passwordValidateFailure(state, action) {
  return updateObject(state, {
    passwordValidate: updateObject(state.passwordValidate, {
      success: false,
      message: action.data.message
    })
  });
}

function clearPassMessages(state, action) {
  const updatedState = { ...state };
  delete updatedState.passwordReset;
  delete updatedState.passwordValidate;
  delete updatedState.updatePassword;
  delete updatedState.cancelAccount;
  delete updatedState.subUserValidate;
  return updatedState;
}

function updatePasswordAuthStart(state, action) {
  return updateObject(state, {
    updatePassword: {
      loading: true
    }
  });
}

function updatePasswordAuthSuccess(state, action) {
  return updateObject(state, {
    updatePassword: {
      loading: false,
      success: true,
      message: action.message.message
    }
  });
}

function updatePasswordAuthFailure(state, action) {
  return updateObject(state, {
    updatePassword: {
      loading: false,
      success: false,
      message: action.message.message
    }
  });
}

function cancelAccountSuccess(state) {
  return updateObject(state, {
    cancelAccount: {
      success: true
    }
  });
}

function toggleRememberMe(state, action) {
  localStorage.setItem(
    "rememberMe",
    JSON.stringify({ rememberMe: action.flag, loggedInTime: "" })
  );
  return state;
}

function startRedirect(state, action) {
  const updatedState = { ...state };
  if (action.bool === true) {
    updatedState.redirect = true;
  } else {
    updatedState.redirect = false;
  }
  return updateObject(state, updatedState);
}

function PNSDown(state, action) {
  return updateObject(state, {
    pnsDown: action.bool
  });
}

function fetchAllClientsVersionSuccess(state, action) {
  return updateObject(state, {
    versionInfo: { data: action.data, status: action.status }
  });
}

function validateSubUserStart(state, action) {
  return updateObject(state, {
    subUserValidate: {}
  });
}

function validateSubUserSuccess(state, action) {
  return updateObject(state, {
    subUserValidate: updateObject(state.subUserValidate, {
      success: true,
      message: action.data
    })
  });
}

function validateSubUserFailure(state, action) {
  return updateObject(state, {
    subUserValidate: updateObject(state.subUserValidate, {
      success: false,
      message: action.data.message
    })
  });
}

function createSubUserStart(state, action) {
  return updateObject(state, {
    signup: updateObject(state.signup, {
      loading: true,
      error: {
        show: false,
        msg: ""
      }
    })
  });
}

function fetchPromoDiscountSuccess(state, action) {
  return updateObject(state, {
    promoValidate: updateObject(state.promoValidate, {
      success: true,
      message: action.data.message
    })
  });
}

function validate360Failure(state, action) {
  return updateObject(state, {
    validate360: updateObject(state.validate360, {
      success: false,
      message: action.data.message
    })
  });
}

function validateIbackupFailure(state, action) {
  return updateObject(state, {
    validateIbackup: updateObject(state.validate360, {
      success: false,
      message: action.data.message
    })
  });
}

function fetchPromoDiscountFailure(state, action) {
  return updateObject(state, {
    promoValidate: updateObject(state.promoValidate, {
      success: false,
      message: action.data.message
    })
  });
}

function reducer(state = deepClone(initState), action) {
  switch (action.type) {
    case types.SHOW_LOGIN_PAGE:
      return showLoginPage(state);
    case types.LOGIN_USER_START:
      return loginUserStart(state);
    case types.SET_IS_FIRST_TIME:
      return setIsFirstTime(state);
    case types.SET_IS_WELCOME:
      return setIsWelcome(state);
    case types.LOGIN_USER_SUCCESS:
      return loginUserSuccess(state, action);
    case types.SHOW_LOGIN_ERROR:
      return showLoginError(state, action);
    case types.HIDE_LOGIN_ERROR:
      return hideLoginError(state);
    case types.LOGOUT_USER:
      return logoutUser(state, action);
    case types.CREATE_ACCOUNT_START:
      return createAccountStart(state, action);
    case types.CREATE_ACCOUNT_FAILURE:
      return createAccountFailure(state, action);
    case types.CREATE_ACCOUNT_SUCCESS:
      return createAccountSuccess(state, action);
    case types.CHECK_AUTH_START:
      return checkAuthStart(state);
    case types.CHECK_AUTH_SUCCESS:
      return checkAuthSuccess(state, action);
    case types.CLEAN_LOCAL_STORAGE:
      return cleanLocalStorage(state);
    case types.PASSWORD_RESET_START:
      return passwordResetStart(state, action);
    case types.PASSWORD_RESET_SUCCESS:
      return passwordResetSuccess(state, action);
    case types.PASSWORD_RESET_FAILURE:
      return passwordResetFailure(state, action);
    case types.PASSWORD_VALIDATE_START:
      return passwordValidateStart(state, action);
    case types.PASSWORD_VALIDATE_SUCCESS:
      return passwordValidateSuccess(state, action);
    case types.PASSWORD_VALIDATE_FAILURE:
      return passwordValidateFailure(state, action);
    case types.CLEAR_PASS_MESSAGES:
      return clearPassMessages(state, action);
    case types.UPDATE_PASSWORD_AUTH_START:
      return updatePasswordAuthStart(state, action);
    case types.UPDATE_PASSWORD_AUTH_SUCCESS:
      return updatePasswordAuthSuccess(state, action);
    case types.UPDATE_PASSWORD_AUTH_FAILURE:
      return updatePasswordAuthFailure(state, action);
    case types.CANCEL_ACCOUNT_SUCCESS:
      return cancelAccountSuccess(state);
    case types.TOGGLE_REMEMBER_ME:
      return toggleRememberMe(state, action);
    case types.RESET_REGISTRATION_FAILED_MEESAGE:
      return resetRegistrationFailedMessage(state);
    case types.START_REDIRECT:
      return startRedirect(state, action);
    case types.PNS_DOWN:
      return PNSDown(state, action);
    case types.FETCH_ALL_CLIENTS_VERSION_SUCCESS:
      return fetchAllClientsVersionSuccess(state, action);
    case types.VALIDATE_SUB_USER_START:
      return validateSubUserStart(state, action);
    case types.VALIDATE_SUB_USER_SUCCESS:
      return validateSubUserSuccess(state, action);
    case types.VALIDATE_SUB_USER_FAILURE:
      return validateSubUserFailure(state, action);
    case types.CREATE_SUB_USER_START:
      return createSubUserStart(state, action);
    case types.FETCH_PROMO_DISCOUNT_SUCCESS:
      return fetchPromoDiscountSuccess(state, action);
    case types.FETCH_PROMO_DISCOUNT_FAILURE:
      return fetchPromoDiscountFailure(state, action);
    case types.CREATE_PROMO_ACCOUNT_START:
      return createPromoAccountStart(state, action);
    case types.VALIDATE_360_FAILURE:
      return validate360Failure(state, action);
    case types.VALIDATE_IBACKUP_FAILURE:
      return validateIbackupFailure(state, action);
    default:
      return state;
  }
}

export default reducer;
